import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { postContact } from '../../features/contact/contactSlice'

import estate2 from '../../assets/estate1.jpg'

const Contact = () => {
	const dispatch = useDispatch()

	const { loading } = useSelector((state) => state.postContact)

	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [email, setEmail] = useState('')
	const [message, setMessage] = useState('')
	const [phone, setPhone] = useState('')

	const submitHandler = (e) => {
		e.preventDefault()

		const data = {
			name: `${firstName} ${lastName}`,
			email,
			phone,
			message,
		}
		dispatch(postContact(data))

		setTimeout(() => {
			setLastName('')
			setFirstName('')
			setPhone('')
			setEmail('')
			setMessage('')
		}, 300)
	}

	useEffect(() => {
		return () => {
			// dispatch({ type: POST_CONTACT_RESET })
		}
	}, [dispatch])

	return (
		<main className='contact_page'>
			<section
				className='section novi-background breadcrumbs-custom bg-image context-dark'
				style={{ backgroundImage: `url(${estate2})` }}
			>
				<div className='breadcrumbs-custom-inner'>
					<div className='container breadcrumbs-custom-container'>
						<div className='breadcrumbs-custom-main'>
							<h6
								className='breadcrumbs-custom-subtitle title-decorated'
								style={{ color: 'transparent' }}
							>
								Contacts
							</h6>
							<h2 className='text-uppercase breadcrumbs-custom-title'>
								Contacts
							</h2>
						</div>
						<ul className='breadcrumbs-custom-path'>
							<li>
								<Link to='/'>Home</Link>
							</li>
							<li className='active'>Contacts</li>
						</ul>
					</div>
				</div>
			</section>
			<section className='section novi-background section-sm'>
				<div className='container'>
					<div className='layout-bordered'>
						<div className='layout-bordered-item wow-outer'>
							<div className='layout-bordered-item-inner wow slideInUp'>
								<div className='icon novi-icon icon-lg mdi mdi-phone text-primary'></div>
								<ul className='list-0'>
									<li>
										<a className='link-default' href='tel:#'>
											1-800-1234-678
										</a>
									</li>
									<li>
										<a className='link-default' href='tel:#'>
											1-800-9876-098
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className='layout-bordered-item wow-outer'>
							<div className='layout-bordered-item-inner wow slideInUp'>
								<div className='icon novi-icon icon-lg mdi mdi-email text-primary'></div>
								<a className='link-default' href='mailto:#'>
									info@demolink.org
								</a>
							</div>
						</div>
						<div className='layout-bordered-item wow-outer'>
							<div className='layout-bordered-item-inner wow slideInUp'>
								<div className='icon novi-icon icon-lg mdi mdi-map-marker text-primary'></div>
								<a className='link-default' href='#'>
									2130 Fulton Street San Diego, CA 94117-1080 USA
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className='section novi-background bg-gray-100'>
				<div className='range justify-content-xl-between'>
					<div className='cell-xl-6 align-self-center container'>
						<div className='row'>
							<div className='col-lg-9 cell-inner'>
								<div className='section-lg'>
									<h3 className='text-uppercase wow-outer'>
										<span className='wow slideInDown green_text'>
											Contact Us
										</span>
									</h3>

									<form
										className='rd-form rd-mailform'
										onSubmit={submitHandler}
									>
										<div className='row row-10'>
											<div className='col-md-6 wow-outer'>
												<div className='form-wrap wow fadeSlideInUp'>
													<label
														htmlFor='contact-first-name'
														className='form-label-outside'
													>
														First Name
													</label>
													<input
														className='form-input'
														id='contact-first-name'
														type='text'
														value={firstName}
														required
														onChange={(e) => setFirstName(e.target.value)}
													/>
												</div>
											</div>
											<div className='col-md-6 wow-outer'>
												<div className='form-wrap wow fadeSlideInUp'>
													<label className='form-label-outside'>
														Last Name
													</label>
													<input
														className='form-input'
														id='contact-last-name'
														type='text'
														value={lastName}
														required
														onChange={(e) => setLastName(e.target.value)}
													/>
												</div>
											</div>
											<div className='col-md-6 wow-outer'>
												<div className='form-wrap wow fadeSlideInUp'>
													<label className='form-label-outside'>E-mail</label>
													<input
														className='form-input'
														id='contact-email'
														type='email'
														value={email}
														required
														onChange={(e) => setEmail(e.target.value)}
													/>
												</div>
											</div>
											<div className='col-md-6 wow-outer'>
												<div className='form-wrap wow fadeSlideInUp'>
													<label className='form-label-outside'>Phone</label>
													<input
														className='form-input'
														id='contact-phone'
														type='text'
														value={phone}
														required
														onChange={(e) => setPhone(e.target.value)}
													/>
												</div>
											</div>
											<div className='col-12 wow-outer'>
												<div className='form-wrap wow fadeSlideInUp'>
													<label className='form-label-outside'>
														Your Message
													</label>
													<textarea
														className='form-input'
														id='contact-message'
														value={message}
														required
														onChange={(e) => setMessage(e.target.value)}
													></textarea>
												</div>
											</div>
										</div>
										<div className='group group-middle'>
											<div className='wow-outer'>
												<button
													className='button button-primary-outline btn_showel button-icon button-icon-left button-winona wow slideInLeft'
													type='submit'
												>
													{loading ? (
														<i className='fas fa-spinner fa-spin'></i>
													) : (
														'Send Message'
													)}
												</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}

export default Contact
